export const validateNotEmpty = value => {
  return [!!value, {
    error: !value,
    helperText: !!value ? undefined : 'Không được để trống',
  }];
};
